export enum ApiOnboardingTaskName {
  utilityBill = 'utilityBill',
  ach = 'ach',
  identityVerification = 'identityVerification',
  titleVerification = 'titleVerification',
  voidedCheck = 'voidedCheck',
  utilityBillRequirement = 'utilityBillRequirement',
}

export enum OnboardingTaskTrackingId {
  utilityBill = 'energy-bill',
  ach = 'direct-debit',
  identityVerification = 'identity-verification',
  titleVerification = 'title-verification',
  voidedCheck = 'voided-check',
  utilityBillRequirement = 'utility-bill-requirement',
}

export enum ApiOnboardingTaskStatus {
  requiresAction = 'requiresAction',
  pending = 'pending',
  requiresReview = 'requiresReview',
  requiresVerification = 'requiresVerification',
  complete = 'complete',
  rejected = 'rejected',
}

export type ApiSiteSurveyResponse = {
  id: string;
  question: string;
  answer: string | number | { label?: string; labels?: string[] };
  viewUrl?: string;
};

export type ApiDocument = {
  contentType: string;
  data: string;
  uploadedAt: string;
};

export enum ApiNoUtilityBillReason {
  newConstruction = 'newConstruction',
  newHomeowner = 'newHomeowner',
  other = 'other',
}

export type ApiIsApplicable = 'Yes' | 'No' | 'Unknown';

export interface ApiOnboardingTaskData {
  value?: string;
  responses?: ApiSiteSurveyResponse[];
  utilityBills?: ApiDocument[];
  noUtilityBillReason?: string;
  isHoa?: ApiIsApplicable;
  note?: string;
  url?: string;
  result?: string;
  verificationUrl?: string;
  documents?: ApiDocument[];
}

export interface OnboardingTaskData extends ApiOnboardingTaskData {
  documentUrls?: DocumentFile[];
}

export interface DocumentFile {
  type: string;
  name: string;
  url: string;
}

export interface ApiOnboardingError {
  message: string;
}

export interface ApiOnboardingTask {
  name: ApiOnboardingTaskName;
  status: ApiOnboardingTaskStatus;
  lastUpdatedAt?: Date;
  data?: ApiOnboardingTaskData;
  alNoteId?: number;
  error?: ApiOnboardingError;
  noUtilityBill?: boolean;
  applicationId?: string;
}

export interface OnboardingTask {
  name: ApiOnboardingTaskName;
  status: string;
  label: string;
  updatedDate?: Date;
  data?: OnboardingTaskData;
  page?: string;
  error?: ApiOnboardingError;
  applicationId?: string;
}

export interface UpdateNoUtilityBillParams {
  reason: ApiNoUtilityBillReason;
  description?: string;
}

export interface ApiPostSolarTariff {
  lseId: string;
  lseName: string;
  postSolarMasterTariffId: number;
  tariffName: string;
}

export interface ApiSolarTariff {
  postSolarTariff: ApiPostSolarTariff | Record<string, never>;
}

export enum OnboardingAnalyticsEvent {
  updated = 'onboarding task updated',
  completed = 'onboarding task completed',
}
